import {Component, EventEmitter, Input, Output} from "@angular/core";

import {FontAwesomeModule} from "@fortawesome/angular-fontawesome";
import {FormsModule} from "@angular/forms";
import {IconDefinition} from "@fortawesome/free-solid-svg-icons";
import {MatCheckboxModule} from "@angular/material/checkbox";
import {
  FullProblemTemplate
} from "../../../../admin/feature/contentViewer/problemTemplatePreview/problemTemplatePreview.component";

@Component({
    selector: 'decimal',
    styleUrls: ['../../../../admin/feature/userManagement/userRoleAddEdit/userRoleAddEdit.css'],
    imports: [FontAwesomeModule, FormsModule, MatCheckboxModule],
    templateUrl: './decimal.component.html'
})
export class DecimalComponent {
  @Input('review') review: boolean = false;
  @Input('problem_template') problem_template!: FullProblemTemplate
  @Input('answer') answer?: string = ''
  @Output() answerChange = new EventEmitter<string>()
  @Output() onChangeEmitter = new EventEmitter<Function>()

  onChange(answer: string | undefined) {
    if(answer != undefined) {
      this.answerChange.emit(answer)
      this.onChangeEmitter.emit(this.onChangeEmitter)
    }
  }
}
